import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core"
import { VisibilityOffOutlined, VisibilityOutlined } from "@material-ui/icons"
import { resetPassword } from "~/actions/users"
import LoaderButton from "~/components/LoaderButton/index.jsx"
import App from "~/contexts/App"
import { Form, Formik } from "formik"
import useOpenErrorSnackbar from "~/hooks/useOpenErrorSnackbar"
import { useContext, useState } from "react"
import { useMutation } from "react-query"
import * as Yup from "yup"

import useStyles from "./styles"
const ConfirmPassword = () => {
  const classes = useStyles()
  const { dialogs, closeDialog } = useContext(App)
  const thisDialog = dialogs?.["confirmPassword"] || {}
  const magicCode = thisDialog?.data?.magic_code
  const magicHash = thisDialog?.data?.magic_hash
  const { open = false, data } = thisDialog

  const { openSnackBar } = useContext(App)
  const openErrorSnackbar = useOpenErrorSnackbar()
  const resetPassworMutation = useMutation(resetPassword)
  const [visibility, setVisibility] = useState(true)
  const [visibilityConfirm, setVisibilityConfirm] = useState(true)

  const schema = Yup.object().shape({
    password: Yup.string()
      .matches(
        /^(?=.*[\d])(?=.*[!@#$%^&*()_\-+={[}\]|\\:;"'<,>.?/])(?=.*[A-Z])[A-Za-z\d!@#$%^&*()_\-+={[}\]|\\:;"'<,>.?/]{8,}$/,
        "Must contain at least 8 characters, one number, and one special character",
      )
      .required("Password is required"),
    confirmPassword: Yup.string().required("Confirm Password is required"),
  })
  const handleClose = () => {
    closeDialog("confirmPassword", false)
    setVisibility(true)
    setVisibilityConfirm(true)
  }

  //checks if password values are equal, makes reset password call w hash/code
  const onSubmit = (values, actions) => {
    if (values.password === values.confirmPassword) {
      resetPassworMutation.mutate(
        {
          magic_code: magicCode,
          magic_hash: magicHash,
          password: values.password,
        },
        {
          onSuccess: () => {
            openSnackBar({ message: "Your password was reset." })
            handleClose()
          },
          onError: (err) => openErrorSnackbar(err, "Error resetting password"),
        },
      )
    } else {
      actions.setSubmitting(false)
      openSnackBar({ message: "Error. Passwords do not match" })
    }
  }

  return (
    <Dialog classes={{ paperWidthSm: classes.dialogMinHeight }} open={open}>
      <DialogTitle className={classes.dialogTitle} disableTypography>
        <Typography variant="h2" className={classes.title}>
          Reset Password
        </Typography>
      </DialogTitle>
      <Formik
        initialValues={{ password: "", confirmPassword: "" }}
        onSubmit={onSubmit}
        validationSchema={schema}
      >
        {({
          handleChange,
          values,
          errors,
          touched,
          handleBlur,
          isSubmitting,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <DialogContent className={classes.dialogContent}>
              <Typography color="secondary" className={classes.title}>
                New Password
              </Typography>

              <TextField
                type={visibility ? "password" : "text"}
                name="password"
                value={values.password}
                // placeholder="Email"
                // label="Email"
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={
                  <span>
                    {touched.password && errors.password
                      ? errors.password
                      : " "}
                  </span>
                }
                InputProps={{
                  classes: {
                    root: classes.inputBackgroundColor,
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        size="small"
                        onClick={() => setVisibility(!visibility)}
                      >
                        {visibility ? (
                          <VisibilityOffOutlined
                            color="primary"
                            fontSize="small"
                          />
                        ) : (
                          <VisibilityOutlined
                            color="primary"
                            fontSize="small"
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={!!touched.password && !!errors.password}
                variant="outlined"
                size="small"
                fullWidth
                FormHelperTextProps={{
                  className: classes.formHelperText,
                }}
              />
              <Typography color="secondary" className={classes.title}>
                Confirm New Password
              </Typography>

              <TextField
                type={visibilityConfirm ? "password" : "text"}
                name="confirmPassword"
                value={values.confirmPassword}
                // placeholder="Email"
                // label="Email"
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={
                  <span>
                    {touched.confirmPassword && errors.confirmPassword
                      ? errors.confirmPassword
                      : " "}
                  </span>
                }
                InputProps={{
                  classes: {
                    root: classes.inputBackgroundColor,
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        size="small"
                        onClick={() => setVisibilityConfirm(!visibilityConfirm)}
                      >
                        {visibilityConfirm ? (
                          <VisibilityOffOutlined
                            color="primary"
                            fontSize="small"
                          />
                        ) : (
                          <VisibilityOutlined
                            color="primary"
                            fontSize="small"
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={touched.confirmPassword && errors.confirmPassword}
                variant="outlined"
                size="small"
                fullWidth
                FormHelperTextProps={{
                  className: classes.formHelperText,
                }}
              />
            </DialogContent>
            <DialogActions
              style={{
                position: "absolute",
                bottom: 4,
                right: 16,
              }}
            >
              <LoaderButton
                type="submit"
                // onClick={onSubmit}
                classoverrides={{
                  wrapper: classes.button,
                  button: {
                    root: classes.buttonRoot,
                  },
                }}
                variant="contained"
                color="secondary"
                working={isSubmitting}
                size="small"
              >
                Save
              </LoaderButton>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}

export default ConfirmPassword
